var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalcManHead(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "27px",
    viewBox: "0 0 25 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CalcManHead") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CalcManHead",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.9959792,17.8344934 C24.8114106,24.1497964 19.0077557,27.8981426 14.2704966,25.011205 C9.5229838,22.1232516 5.83161314,14.6631285 6.00592786,8.34782553 C6.1904964,2.03353836 10.1689737,-0.745723169 14.9062327,2.14121443 C19.6434917,5.02916784 25.1702939,11.5202063 24.9959792,17.8344934",
    id: "Fill-415",
    fill: "#ED5353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.23403211,23.5373571 C3.23403211,23.5373571 4.37175645,27.7446311 11.8552363,26.8838925 C17.5046261,26.2330657 13.4539352,16.3069523 18.6227345,13.8492775 C25.615816,10.5258424 22.8597769,3.51438859 19.7604589,1.22544672 C16.6709488,-1.06449951 12.7477615,0.258245747 7.90262507,1.91644804 C2.78286557,3.67006476 -4.180792,7.72768879 3.23403211,23.5373571",
    id: "Fill-417",
    fill: "#27427A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9986226,15.5693918 C19.9620761,16.9499224 18.8108628,18.0373642 17.4312342,17.9990162 C16.0516055,17.959755 14.9643485,16.8111389 15.000895,15.4306082 C15.0374414,14.0500776 16.1886547,12.9626358 17.5682834,13.0009838 C18.947912,13.040245 20.0443056,14.1897741 19.9986226,15.5693918",
    id: "Fill-418",
    fill: "#ED5353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8503029,17.9919786 L18.8503029,17.9919786 C18.3130613,18.0578291 17.818799,17.7108854 17.7435852,17.2214295 L16.0029224,11.5130754 C15.9277086,11.0236194 17.3245368,11.3125753 17.8617784,11.2477077 C18.3882752,11.1818572 19.9247862,10.737612 20,11.227068 L19.6883999,16.9835814 C19.7636137,17.4730374 19.3767997,17.927111 18.8503029,17.9919786",
    id: "Fill-423",
    fill: "#27427A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalcManHead);
export default __webpack_public_path__ + "static/media/CalcManHead.106b1e4f661c76ed47d7c3093dbec7b8.svg";
export { ForwardRef as ReactComponent };